import Confirm from '@jetbrains/ring-ui/components/confirm/confirm'
import * as React from 'react'

import SettingsBlock from '../../../../components/SettingsBlock/SettingsBlock'
import {isStoreYamlInVcsEnabled} from '../../../../utils/featureToggles'

import ConfigurationStorageSection from './ConfigurationStorageSection/ConfigurationStorageSection'
import {
  pipelineRepositorySettingsBlockId,
  usePipelineRepositories,
} from './PipelineRepositories.hooks'
import {getFilteredRepositories} from './PipelineRepositories.utils'
import PipelineRepository from './PipelineRepository/PipelineRepository'
import PipelineRepositoryForm from './PipelineRepositoryForm/PipelineRepositoryForm'

import styles from './PipelineRepositories.css'

function PipelineRepositories() {
  const {
    additionalVcsRoots,
    deletedRepositoriesSet,
    shortRepositories,
    isCreateMode,
    mainRepository,
    repositoriesFlat,
    createdRepositories,
    isShowDeleteJobConfirmPopup,
    confirmDeleteJobDescription,
    savedVersionedSettings,
    versionedSettings,
    addRepositoryHandler,
    closeCreateRepositoryFormHandler,
    updateMainRepositoryHandler,
    deleteRepositoryHandler,
    restoreRepositoryHandler,
    changeRepositoryHandler,
    createRepositoryHandler,
    clickConfirmDeleteJobButtonHandler,
    clickRejectDeleteJobButtonHandler,
    changeVersionedSettingsHandler,
  } = usePipelineRepositories()

  return (
    <React.Fragment>
      <Confirm
        description={confirmDeleteJobDescription}
        confirmLabel="Agree"
        rejectLabel="Cancel"
        show={isShowDeleteJobConfirmPopup}
        onConfirm={clickConfirmDeleteJobButtonHandler}
        onReject={clickRejectDeleteJobButtonHandler}
      />
      <SettingsBlock
        id={pipelineRepositorySettingsBlockId}
        title="Repository"
        collapsible
        collapsedNote={shortRepositories}
        onAddClick={addRepositoryHandler}
      >
        <PipelineRepository
          isRoot
          className={styles.settingsFormContainer}
          branch={mainRepository?.branch}
          branchSpec={mainRepository?.branchSpecification}
          repositoryUrl={mainRepository?.url}
          onConfirm={updateMainRepositoryHandler}
        />
        {isStoreYamlInVcsEnabled && (
          <ConfigurationStorageSection
            vcsRoot={mainRepository}
            savedStoredInRepo={savedVersionedSettings?.storedInRepo}
            storedInRepo={versionedSettings?.storedInRepo}
            changeVersionedSettingsHandler={changeVersionedSettingsHandler}
          />
        )}
        {additionalVcsRoots?.map((vcsRoot, index) => {
          const {url, branch, branchSpecification} = vcsRoot
          const repositories = getFilteredRepositories(repositoriesFlat, url, createdRepositories)
          const isDeleted = deletedRepositoriesSet.has(url)

          return (
            <PipelineRepository
              repositories={repositories}
              key={url}
              branch={branch}
              branchSpec={branchSpecification}
              repositoryUrl={url}
              isDeleted={isDeleted}
              onRestore={restoreRepositoryHandler(url)}
              onConfirm={changeRepositoryHandler(index)}
              onDelete={deleteRepositoryHandler(url)}
            />
          )
        })}
        {isCreateMode && (
          <PipelineRepositoryForm
            isCreateMode={isCreateMode}
            className={styles.createFormContainer}
            repositories={getFilteredRepositories(repositoriesFlat, '', createdRepositories)}
            onConfirm={createRepositoryHandler}
            onDelete={closeCreateRepositoryFormHandler}
          />
        )}
      </SettingsBlock>
    </React.Fragment>
  )
}

export default PipelineRepositories
